import React from "react";

import TextField from "Components/TextField.js";

/**
 * TOTP code input
 * 
 * @package HOPS
 * @subpackage Login
 * @copyright Heritage Operations Processing Limited
 */
class LoginFormTotpInput extends React.PureComponent {

	/**
	 * Input
	 *
	 * @type {ReactRef}
	 */
	inputRef = React.createRef();


	/**
	 * Component updated.
	 *
	 * @param {Object} prevProps
	 * @return {void}
	 */
	componentDidUpdate(prevProps) {
		if (prevProps.loginStatus !== this.props.loginStatus) {
			if (this.props.autoFocusOnError && this.props.loginStatus) {
				setTimeout(() => {
					if (this.inputRef?.current) {
						this.inputRef.current.select();
					}
				});
			}
		}
	}


	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<TextField
				autoFocus
				controlled={true}
				disabled={this.props.disabled}
				error={((this.props.loginStatus === 401) || !!this.props.error)}
				helperText={(this.props.helperText || (((this.props.loginStatus === 401) && "Invalid code")))}
				inputRef={(this.props.inputRef || this.inputRef)}
				label="Code"
				name={this.props.name}
				onChange={this.props.onChange}
				required={true}
				varchar={true}
				value={this.props.value} />
		);
	}

}

export default LoginFormTotpInput;
